'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface ConsultationSectionProps {
  currentLanguage: string;
}

const ConsultationSection = ({ currentLanguage }: ConsultationSectionProps) => {
  return (
    <section className="py-20 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 md:p-12 text-white">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="font-heading font-bold text-3xl md:text-4xl mb-4">
                Need Expert Compliance Guidance?
              </h2>
              <p className="text-lg text-white/90 mb-6">
                Our regulatory experts can help you navigate complex frameworks, ensure full compliance, and optimize your ESG strategy.
              </p>

              <div className="space-y-3 mb-8">
                {[
                  'Personalized compliance roadmap',
                  'Regulatory framework selection',
                  'Gap analysis and remediation',
                  'Ongoing compliance monitoring',
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <Icon name="CheckCircleIcon" size={20} className="text-white flex-shrink-0" />
                    <span className="text-white/95">{benefit}</span>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <Link
                  href="/get-started"
                  className="w-full sm:w-auto px-8 py-4 bg-white text-primary font-heading font-semibold text-base rounded-lg hover:bg-white/95 shadow-natural hover:shadow-natural-lg transition-all duration-300 text-center"
                >
                  Schedule Consultation
                </Link>
                <a
                  href="https://wa.me/919876543210"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full sm:w-auto px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 font-heading font-semibold text-base rounded-lg hover:bg-white/20 transition-all duration-300 text-center"
                >
                  <div className="flex items-center justify-center space-x-2">
                    <Icon name="ChatBubbleLeftRightIcon" size={20} />
                    <span>WhatsApp Support</span>
                  </div>
                </a>
              </div>
            </div>

            <div className="hidden md:grid grid-cols-2 gap-4">
              {[
                { icon: 'DocumentTextIcon', label: 'Compliance Reports', value: '500+' },
                { icon: 'BuildingOfficeIcon', label: 'Enterprises Served', value: '120+' },
                { icon: 'UserGroupIcon', label: 'Expert Consultants', value: '25+' },
                { icon: 'ClockIcon', label: 'Avg Response Time', value: '< 24h' },
              ].map((stat, index) => (
                <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
                  <Icon name={stat.icon} size={32} className="text-white mx-auto mb-3" />
                  <div className="text-2xl font-heading font-bold text-white mb-1">{stat.value}</div>
                  <div className="text-sm text-white/80">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultationSection;